module.exports = __webpack_public_path__ + "static/media/up-arrow.95df669c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/up-arrow.svg
// module id = 829
// module chunks = 0